import * as $ from 'jquery';
import { apiBaseUrlUser } from '../../../constants/url.constant';
import { DefaultService } from '../../common/services/DefaultService';

export class PopularSearchService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/popularSearch`;

    public RouteGetOpenList = (count: number) => `${this.baseUrl}/getOpenList?count=${count}`;
    public getOpenList(count: number): JQueryPromise<any> {
        return $.ajax(this.RouteGetOpenList(count), {
            type: 'get',
            contentType: 'application/json'
        });
    }
}